<template>
  <b-row>
    <b-col
      cols="12"
      lg="6"
    >
      <b-form-group>
        <p class="mx-10">
          Selecione a unidade e o melhor dia para sua reserva em seguida
          verifique
          {{ $t('app.os-espacos') }} disponíveis e os horários.
        </p>
        <v-select
          v-model="minhaUnidade"
          class="select-size-lg"
          label="nome"
          :options="minhasUnidades"
          placeholder="Selecione sua unidade..."
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      lg="6"
      align="center"
      class="mb-2"
    >
      <flat-pickr
        v-model="dataReserva"
        class="form-control"
        :config="dateConfig"
        @on-change="novaData"
      />
    </b-col>
    <b-col cols="12">
      <div
        v-for="area in areasDisponiveis"
        :key="area.id"
        class="vx-row"
      >
        <b-card
          :title="area.nome"
          class="mb-2"
        >
          <swiper :options="swiperOption">
            <template v-for="res in area.restricoes">
              <swiper-slide :key="res.id">
                <b-button
                  variant="primary"
                  @click="goToConfirmation(area, res)"
                >
                  {{ res.descricao }}
                </b-button>
              </swiper-slide>
            </template>
          </swiper>
          <p v-if="area.restricoes.length == 0">
            Nenhum espaço disponível
          </p>

          <swiper
            :options="swiperOption"
            class="mt-2"
          >
            <template v-for="evt in area.eventosBag">
              <swiper-slide :key="evt.id">
                <b-button
                  variant="outline-secondary"
                  :to="'/reservas/view/' + evt.id"
                >
                  Reservado para {{ evt.unidade.descricao }} -
                  {{ evt.restricao.descricao }}
                </b-button>
              </swiper-slide>
            </template>
          </swiper>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'

export default {
  components: {
    flatPickr,
    Swiper,
    SwiperSlide,
    vSelect,
    BFormGroup,
  },
  data() {
    const ontem = new Date()
    ontem.setDate(ontem.getDate() - 1)
    return {
      dateConfig: {
        dateFormat: 'Z',
        locale: Portuguese,
        inline: true,
        disable: [
          selectedDate => {
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            return selectedDate < today
          },
        ],
      },
      swiperOption: {
        slidesPerView: 1.5,
        slidesPerColumn: 1,
        spaceBetween: 50,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
        },
      },
      minhaUnidade: null,
      dataReserva: new Date(),
    }
  },
  computed: {
    areasDisponiveis() {
      return this.$store.state.reserva.areasDisponiveis
    },
    minhasUnidades() {
      return this.$store.state.unidade.minhasUnidades
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    minhaUnidade(newVal, oldVal) {
      if (newVal && this.dataReserva) {
        this.fetchAreasDisponiveis({ data: this.dataReserva, unidade: newVal })
      } else {
        this.$store.dispatch('reserva/clearAreasDisponiveis')
      }
    },
  },
  created() {
    this.clearReservaEmAndamento()
    this.clearAreasDisponiveis()
    this.$store.dispatch('unidade/fetchMinhasUnidades').then(() => {
      const [unidade] = this.minhasUnidades
      this.minhaUnidade = unidade
    })
    this.$store.dispatch('unidade/fetchUnidades', { page: 0 })
  },
  mounted() {},
  methods: {
    novaData(date) {
      this.fetchAreasDisponiveis({ data: date[0], unidade: this.minhaUnidade })
    },
    goToConfirmation(area, res) {
      this.$loading.show()

      if (!this.dataReserva) {
        this.$toast.warning('Você precisa informar uma data prosseguir')
        this.$loading.hide()
        return
      }
      if (!this.minhaUnidade || !res) {
        this.$toast.warning('Você precisa informar uma unidade para prosseguir')
        this.$loading.hide()
        return
      }

      this.$store
        .dispatch('reserva/reservaEmAndamento', {
          unidade: { id: this.minhaUnidade.id },
          restricao: { id: res.id },
          areaComum: { id: area.id, nome: area.nome },
          dataHoraInicio: this.dataReserva,
        })
        .then(() => {
          this.$loading.hide()
          this.$router.push('/reservas/confirmation')
        })
        .catch(() => this.$loading.hide())
    },

    clearReservaEmAndamento() {
      this.$store.dispatch('reserva/reservaEmAndamento', {})
    },

    clearAreasDisponiveis() {
      return this.$store.dispatch('reserva/clearAreasDisponiveis')
    },

    fetchAreasDisponiveis(params) {
      return this.$store.dispatch('reserva/fetchAreasDisponiveis', params)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.flatpickr-input {
  display: none;
}
</style>
